<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M707.5 71.5H236.1c-66.8 0-121 54.2-121 121v638c0 66.8 54.2 121 121 121H786c66.8 0 121-54.2 121-121V271L707.5 71.5zm140.4 765.7c0 31-25.1 56.1-56.1 56.1h-561c-31 0-56.1-25.1-56.1-56.1V186.4c0-31 25.1-56.1 56.1-56.1h451.9l165.2 165.2v541.7z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M395.2 304.6c-14.4-11.2-35.1-8.7-46.3 5.7s-8.7 35.1 5.7 46.3l115 89.9h-94.7c-18.2 0-33 14.8-33 33s14.8 33 33 33H478V553H374.9c-18.2 0-33 14.8-33 33s14.8 33 33 33H478v73.4c0 18.2 14.8 33 33 33s33-14.8 33-33V619h103.1c18.2 0 33-14.8 33-33s-14.8-33-33-33H544v-40.4h103.1c18.2 0 33-14.8 33-33s-14.8-33-33-33h-94.7l115.1-89.9c14.4-11.2 16.9-32 5.7-46.3-11.2-14.4-32-16.9-46.3-5.7L511 395.1l-115.8-90.5zM907 271z" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
